<template>
    <b-badge
        v-if="isBadge"
        pill
        :variant="badgeVariant"
        class="date-time-cell-badge"
        :style="{ fontSize: `${badgeSize}rem` }"
    >
        {{ valueFormatted }}
    </b-badge>
    <span v-else>{{ valueFormatted }}</span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';

    export default {
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat', 'userTimeFormat']),
            valueFormatted() {
                return this.value
                    ? format(parseISO(this.value), `${this.userUnicodeDateFormat} ${this.userTimeFormat}`)
                    : ''
            },
            isBadge() {
                return !!this.params.isBadge;
            },
            badgeVariant() {
                return this.params.badgeVariant;
            },
        },
        data() {
            return {
                value: null,
            };
        },
        created() {
            this.value = this.params.value;
            this.badgeSize = 0.9;
        },
    }
</script>

<style lang="scss" scoped>
.date-time-cell-badge {
    padding-top: 0.32rem !important;
}
</style>
